import {type RenderEffects, RENDER_EFFECT} from '../../common/constants';

const EFFECTS = Object.values(RENDER_EFFECT);

export const isRenderEffects = (t: unknown): t is RenderEffects => {
    if (typeof t !== 'string') {
        return false;
    }
    return EFFECTS.some(effect => effect === t);
};

export const isMediaStreamVideoTrack = (
    t: MediaStreamTrack,
): t is MediaStreamVideoTrack => t.kind === 'video';

export function assertMediaStreamVideoTrack(
    t: MediaStreamTrack,
): asserts t is MediaStreamVideoTrack {
    if (!isMediaStreamVideoTrack(t)) {
        throw new TypeError('Not a video track', {cause: t});
    }
}
